import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import trns from './trns';
import Constraints from '../../shared-components/Constraints/Constraints';
import NextImage from '../../shared-components/NextImage/NextImage';
import NavigationLink from '../../shared-components/NavigationLink/NavigationLink';
import { generateHomePageLink } from '../../utils/links';

const bookingImg = 'tradename/drugBooking.svg';
const cartImg = 'tradename/cart.svg';
const locationImg = 'tradename/pharmacyLocation.svg';
const searchImg = 'tradename/search.svg';

const getDescriptionBlocks = (isPriceExists: boolean) => [
  {
    image: searchImg,
    imgWidth: 23,
    imgHeight: 23,
    title: trns.searchDrugsTitle,
    description: trns.searchDrugsDescription
  },
  {
    image: locationImg,
    imgWidth: 18,
    imgHeight: 26,
    title: trns.pharmacyWithDrugsTitle,
    description: trns.pharmacyWithDrugsDescription
  },
  {
    image: bookingImg,
    imgWidth: 24,
    imgHeight: 26,
    title: trns.bookingTitle,
    description: trns.bookingDescription
  },
  {
    image: cartImg,
    imgWidth: 26,
    imgHeight: 26,
    title: trns.buyTitle,
    description: isPriceExists
      ? trns.buyDescription
      : trns.buyWithoutPriceDescription
  }
];

interface Props {
  tradename: string;
  maxPrice: number;
  minPrice: number;
}
const TextBlock: FC<Props> = ({ tradename, maxPrice, minPrice }) => {
  const isPriceExists = maxPrice !== 0 || minPrice !== 0;
  return (
    <Constraints className="flex w-full pt-8 pb-7 relative w-[90%]">
      <ul className="pt-4 grid gap-y-8 gap-x-7 grid-cols-1 sm:grid-cols-2">
        {getDescriptionBlocks(isPriceExists).map((block, index) => {
          return (
            <li key={index} className="flex">
              <NextImage
                alt={block.title.defaultMessage}
                src={block.image}
                layout="fixed"
                width={23}
                height={23}
              />
              <div className="flex-column ml-4">
                <h3 className={cn('fs-title2')}>
                  <FormattedMessage {...block.title} values={{ tradename }} />
                </h3>
                <p className={cn('fs-body-reg text-astronautBlue pt-4')}>
                  <FormattedMessage
                    {...block.description}
                    values={{
                      tradename,
                      maxPrice,
                      minPrice,
                      link: (
                        <NavigationLink
                          passClassName="text-astronautBlue"
                          href={generateHomePageLink()}
                        >
                          Likie.ua
                        </NavigationLink>
                      )
                    }}
                  />
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </Constraints>
  );
};

export default TextBlock;
